<template>
  <div>
    <b-container fluid>
      <h1>グループ構成</h1>
      <b-form-group
        label="システム構成No."
        label-cols="3"
        label-for="system_config_no"
        label-align="left"
        required
      >
        <b-form-select
          id="system_config_no"
          v-model="system_config_no"
          :options="system_config_no_options"
          @input="changeSystemConfigNo"
          number
        ></b-form-select>
      </b-form-group>
      <b-form-group
        label="グループ番号"
        label-cols="3"
        label-for="group_no"
        label-align="left"
        required
      >
        <b-form-select
          id="group_no"
          v-model="group_no"
          :options="group_options"
          @input="changeGroup"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        label="冷媒系統"
        label-cols="3"
        label-for="refregrant"
        label-align="left"
        required
      >
        <template>
          <b-form-checkbox-group
            id="ref-checkbox"
            v-model="selected_refregrant"
            :options="ref_address_list"
            buttons
            button-variant="outline-secondary"
            @input="changeRef"
          ></b-form-checkbox-group>
        </template>
      </b-form-group>
      <b-form-group
        label="コントローラー系統"
        label-cols="3"
        label-for="controllers"
        label-align="left"
        required
      >
        <template>
          <b-form-checkbox-group
            id="rc-checkbox"
            v-model="selected_controllers"
            :options="rc_address_list"
            buttons
            button-variant="outline-secondary"
            @input="changeRc"
          ></b-form-checkbox-group>
        </template>
      </b-form-group>
    </b-container>
    <b-container>
      <b-table
        border
        :items="table_items"
        :fields="table_fields"
      ></b-table>
    </b-container>
    <b-row align-h="center">
      <template>
        <b-button variant="outline-secondary" @click="submitGroupConfig">保存</b-button>
      </template>
      <button @click="displayResumeModal = !displayResumeModal" class="btn btn-outline-secondary">戻る</button>
      <b-modal v-model="displayResumeModal" hide-footer>
        <b-row align-h="around">
          <p>移動してよろしいですか？</p>
        </b-row>
        <b-row align-h="around">
          <button class="btn btn-outline-secondary" @click="pageBack">はい</button>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-row>
  </div>
</template>
<script>
import convertGroupTable from '../../../utils/convertGroupTable'
import { API, graphqlOperation } from 'aws-amplify'
import {
  setRefAddressList,
  setRcAddressList
} from '../../../utils/createAddressList'
import skelton from '../../../utils/DefaultGroupConfigFrontendData.json'
export default {
  name: 'SystemConfig',
  data () {
    return {
      displayResumeModal: false,
      system_config_data: [],
      system_config_no: 1,
      system_config_no_options: [],
      group_no: 1,
      group_options: [1, 2, 3, 4, 5, 6, 7, 8],
      group_config_data: [],
      selected_refregrant: [],
      selected_controllers: [],
      ref_address_list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      rc_address_list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      table_items: [],
      table_fields: [
        {
          key: 'system_config_no',
          label: 'システムNo.'
        },
        {
          key: 'group_no',
          label: 'グループ番号'
        },
        {
          key: 'type',
          label: '冷媒系/コントローラー系'
        },
        {
          key: 'address',
          label: 'アドレス'
        }
      ],
      initSetAddressCompleted: false
    }
  },
  methods: {
    pageBack () {
      this.$router.go(-1)
    },
    changeSystemConfigNo () {
      this.setAddressList()
      this.setSelectedAddress()
    },
    changeGroup () {
      this.setSelectedAddress()
    },
    changeRef (target) {
      this.setAddressToGroupconfigData()
      this.table_items = convertGroupTable(this.group_config_data)
    },
    changeRc () {
      this.setAddressToGroupconfigData()
      this.table_items = convertGroupTable(this.group_config_data)
    },
    setSelectedAddress () {
      if (this.group_config_data[this.system_config_no - 1].length < this.group_no) {
        this.selected_refregrant = []
        this.selected_controllers = []
      } else {
        this.selected_refregrant = this.group_config_data[this.system_config_no - 1][this.group_no - 1]['Refrigerant']
        this.selected_controllers = this.group_config_data[this.system_config_no - 1][this.group_no - 1]['Controller']
      }
    },
    setAddressToGroupconfigData () {
      const target = this.group_config_data[this.system_config_no - 1]
      if (target.length >= this.group_no) {
        target.forEach(elm => {
          if (elm.No === this.group_no) {
            elm.Refrigerant = this.selected_refregrant
            elm.Controller = this.selected_controllers
          }
        })
      } else {
        target.push({
          No: this.group_no,
          Refrigerant: this.selected_refregrant,
          Controller: this.selected_controllers
        })
      }
    },
    setAddressList () {
      const selectedSystemConfig = this.system_config_data[this.system_config_no - 1]
      this.ref_address_list = setRefAddressList(selectedSystemConfig)
      this.rc_address_list = setRcAddressList(selectedSystemConfig)
    },
    submitGroupConfig () {
      try {
        const duplicateList = this.checkAddressDuplicate()
        if (duplicateList.some(elm => { return elm.length > 0 })) {
          this.makeToast('警告', '冷媒系統を複数回使用していますので処理を保存できませんでした。', 'danger')
          return
        }
        this.group_config_data.forEach(async (elm, index) => {
          await API.graphql(graphqlOperation(`
            mutation updateGroupConfig {
              updateGroupConfig (
                no: ${index + 1}
                config: "${JSON.stringify(elm).split('"').join('\\"')}"
              ) {
                no
                config
              }
            }
          `))
        })
        this.makeToast('成功', '保存に成功しました', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '保存に失敗しました', 'danger')
      }
    },
    checkAddressDuplicate () {
      const addressList = this.group_config_data.map(systemConfig => {
        return systemConfig.map(groupConfig => {
          return groupConfig.Refrigerant
        }).filter(elm => {
          return elm !== undefined
        }).reduce((acc, cur) => {
          return acc.concat(cur)
        }, [])
      })
      const duplicateList = addressList.map(address => {
        return address.filter((elm, index, self) => {
          return self.indexOf(elm) !== self.lastIndexOf(elm)
        })
      })
      return duplicateList
    },
    async listSystemConfig () {
      const tempSystemConfigData = await API.graphql(graphqlOperation(`
        query listSystemConfig {
          listSystemConfig {
            items {
              config
            }
          }
        }
      `))
      return tempSystemConfigData.data.listSystemConfig.items.map(elm => { return JSON.parse(JSON.parse(elm.config)) })
    },
    async listGroupConfig () {
      const tempGroupConfigData = await API.graphql(graphqlOperation(`
        query listGroupConfig {
          listGroupConfig {
            items {
              config
            }
          }
        }
      `))
      return tempGroupConfigData.data.listGroupConfig.items.map(elm => { return JSON.parse(JSON.parse(elm.config)) })
    }
  },
  async created () {
    const SYSTEM_CONFIG_DATA = await this.listSystemConfig()
    const GROUP_CONFIG_DATA = await this.listGroupConfig()
    const systemNoList = []
    for (let i = 0; i < SYSTEM_CONFIG_DATA.length; i++) {
      systemNoList.push(i + 1)
    }
    this.system_config_no_options = systemNoList
    this.system_config_data = SYSTEM_CONFIG_DATA
    this.setAddressList()
    for (let i = 0; i < SYSTEM_CONFIG_DATA.length; i++) {
      this.group_config_data.push(JSON.parse(JSON.stringify(skelton)))
    }
    GROUP_CONFIG_DATA.forEach((sysConf, sysConfIndex) => {
      sysConf.forEach((grConf, grConfIndex) => {
        const target = this.group_config_data[sysConfIndex][grConfIndex]
        target.Refrigerant = grConf.Refrigerant
        target.Controller = grConf.Controller
      })
    })
    this.setSelectedAddress()
    this.table_items = convertGroupTable(this.group_config_data)
  }
}
</script>
<style>
  .button-spacer{
    margin-left: 10px;
  }
</style>
